import React from 'react';
import {useParams} from 'react-router-dom';
import EntityPhotoDetail from '../components/photos/EntityPhotoDetail';
export default function RoutePhotoDetail(){
 const {id='',photoId=''}=useParams(),resourcePath='/journal/route-photos/'+encodeURIComponent(id)+'/'+encodeURIComponent(photoId);
 return <EntityPhotoDetail adapter={{kind:'route',entityId:id,photoId,detailPath:resourcePath,resourcePath,removePath:resourcePath,backPath:'/routes/'+encodeURIComponent(id),backLabel:'Back to route',title:'Route photo',removeLabel:'Remove photo',removeConfirmation:'Remove this photo from the route? Its independently shared copies remain available.'}}/>;
}
